/* eslint-disable camelcase */
import * as THREE from 'three'
import { getGeometryArray } from '../utils/getGeometryArray'

export const drawRect = (group, options) => {
  const { color, scale, scene, center_x, center_y, borderColor } = options
  const { y, height, width, x, renderOrder } = group
  const geometry = new THREE.PlaneGeometry(
    (width || 1825) * scale,
    (height || 400) * scale
  )
  const material = new THREE.MeshBasicMaterial({ color })
  const rect = new THREE.Mesh(geometry, material)

  rect.position.set((x - center_x) * scale, -(y - center_y) * scale, 0)
  if (renderOrder) {
    rect.renderOrder = renderOrder
  }

  scene.add(rect)

  if (borderColor) {
    const lineBasicMaterial = new THREE.LineBasicMaterial({
      color: borderColor
    })

    const lineGeometry = new THREE.BufferGeometry()
    const geometryArray = getGeometryArray(geometry)
    const vertices = new Float32Array(geometryArray)

    lineGeometry.setAttribute(
      'position',
      new THREE.BufferAttribute(vertices, 3)
    )
    const line = new THREE.Line(lineGeometry, lineBasicMaterial)
    rect.add(line)
  }
}
